import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class RatingsSlider {
    constructor($el) {
        this.$el = $el;

        this.options = {
            pageDots: true,
            wrapAround: true,
            prevNextButtons: false,
            freeScroll: false,
            groupCells: true,
            cellSelector: '.home-rating-slider__slide',
            cellAlign: 'left'
        };

        if(this.$el.length) {
            this._init();
        }
    }

    _init() {
        this.$slides = this.$el.find('.home-rating-slider__slide');
        this.slidesCount = this.$slides.length;

        if(this.slidesCount > 0) {
            this._createSlider();
        }
    }

    _createSlider() {
        new Flickity(this.$el[0], this.options);
    }
}

export default RatingsSlider;
